"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureTypeEnum = void 0;
var SignatureTypeEnum;
(function (SignatureTypeEnum) {
    SignatureTypeEnum["Queue"] = "Q";
    SignatureTypeEnum["Agent"] = "A";
})(SignatureTypeEnum = exports.SignatureTypeEnum || (exports.SignatureTypeEnum = {}));
